<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to')}} {{$t('currency.singular')}} 
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
              <button 
                type="submit" 
                class="btn2 btn2-primary btn-sm"
              ><i class="uil uil-edit mr-1"></i>{{$t('common.save')}}</button>
          </div>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('currency.form.information')}}</h4>
            <p class="sub-header"></p>

            <div class="row">

              <div class="col-md-2">
                <TextField 
                  :placeholder="$t('currency.form.symbol.placeholder')"
                  :label="$t('currency.form.symbol.label')"
                  v-model="model.symbol"
                  :error="$v.model.symbol.$error"
                  :errorMessage="$v.model.symbol.errorMessage"
                />
              </div>

              <div class="col-md-5">
                <TextField 
                  :placeholder="$t('currency.form.code.placeholder')"
                  :label="$t('currency.form.code.label')"
                  v-model="model.code"
                  :error="$v.model.code.$error"
                  :errorMessage="$v.model.code.errorMessage"
                />
              </div>

              <div class="col-md-5">
                <TextField 
                  :placeholder="$t('currency.form.name.placeholder')"
                  :label="$t('currency.form.name.label')"
                  v-model="model.name"
                  :error="$v.model.name.$error"
                  :errorMessage="$v.model.name.errorMessage"
                />
              </div>

            </div>

            <div class="row">

              <div class="col-md-12">
                <div class="form-group">
                  <label for="remarks" class="form-label">{{$t('currency.form.remarks.placeholder')}}</label>
                  <textarea
                    class="form-control" 
                    name="remarks"
                    :placeholder="$t('currency.form.remarks.placeholder')"
                    rows="10"
                    v-model="model.remarks"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import TextField from '@components/form/textfield.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'


export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        symbol: '',
        code: '',
        name: '',
        remarks: '',
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  validations: {
    model:{
      symbol: { required },
      code: { required },
      name: { required }
    }
  },
  components:{FixedHeader, TextField},
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  created(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('currency', ['create', 'update', 'find']),
    onView() {
      if(this.$route.query.id){
        this.$router.push('/master_files/currency/view?id=' + this.$route.query.id)
      }else{
        this.$router.push('/master_files/currency')
      }
    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}
      
      this[!this.model.id ? 'create' : 'update'](this.model)
      .then(()=> {
        this.toggleLoading()
        this.onView()
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/currency')
    }
  },
  beforeMount() {
    let id = this.$route.query.id
    if(id){
      this.find({
        id:id
      }).then(data => {
        this.model = data.data
        this.model.id = data.data._id
      })
    }
  }
}
</script>

